import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-orderconfirm',
  templateUrl: './order-confirm.component.html',
  styleUrls: ['./order-confirm.component.scss']
})
export class OrderConfirmComponent implements OnInit {
  breadCrumbItems!: Array<{}>;

  readonly = false;
  defaultSelects: number[] = [];
  currentRate = 2;
  customColor = 4;
  hoverSelect = 2;
  hovered = 0;
  clearRate = 2;

  labels: string[] = [];
  questions: string[] = [];
  questionIds: number[] = []; // store partnerQuestionId from API
  orderId: string = '';
  token: string = '';
  idParam: string = '';
  showFeedbackForm: boolean = false;
  feedbackSubmitted: boolean = false;
  isLoadingFeedback: boolean = false;
  isSubmitting: boolean = false;

  constructor(private route: ActivatedRoute, private http: HttpClient) {}

  ngOnInit(): void {
    this.breadCrumbItems = [
      { label: 'Advance UI' },
      { label: 'OrderConfirm', active: true }
    ];

    this.orderId = this.route.snapshot.queryParamMap.get('orderId') || '';
    this.token = this.route.snapshot.queryParamMap.get('token') || '';
    const fParam = this.route.snapshot.queryParamMap.get('F') || '';
    this.idParam = this.route.snapshot.queryParamMap.get('id') || '';

    this.showFeedbackForm = fParam.toLowerCase() === 'true';

    if (this.showFeedbackForm && this.idParam) {
      this.isLoadingFeedback = true;
      this.fetchFeedbackQuestions(this.idParam);
    }
  }

  fetchFeedbackQuestions(id: string): void {
    const apiUrl = `${environment.apiBase}/feedback/questions/orderid/${id}`;
    const headers = new HttpHeaders({
      'accept': '*/*',
      'Authorization': `Bearer ${this.token}`
    });

    this.http.get<any>(apiUrl, { headers }).subscribe({
      next: (res) => {
        if (res?.data?.data) {
          const { partnerQuestions, feedbackRatingTypes } = res.data.data;
          this.questions = partnerQuestions.map((q: any) => q.question);
          this.questionIds = partnerQuestions.map((q: any) => q.partnerQuestionId);
          this.labels = feedbackRatingTypes.map((r: any) => r.label);
          this.defaultSelects = new Array(this.questions.length).fill(0);
        }
        this.isLoadingFeedback = false;
      },
      error: (err) => {
        //console.error('Failed to fetch feedback questions', err);
        this.isLoadingFeedback = false;
      }
    });
  }

  selectRating(questionIndex: number, rating: number) {
    this.defaultSelects[questionIndex] = rating;
  }

  submitFeedback() {
    this.isSubmitting = true;

    const feedbackDetails = this.defaultSelects.map((rating, index) => ({
      partnerQuestionId: this.questionIds[index],
      rating: rating
    }));

    const requestBody = {
      partnerId: 0,
      feedbackDetails: feedbackDetails
    };

    const submitUrl = `${environment.apiBase}/feedback/submit/orderid/${this.idParam}`;
    const headers = new HttpHeaders({
      'accept': '*/*',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.token}`
    });

    this.http.post<any>(submitUrl, requestBody, { headers }).subscribe({
      next: (res) => {
        if (res?.status === 'success') {
          this.feedbackSubmitted = true;
          this.showFeedbackForm = false;
        } else {
          //console.error('Feedback submission failed');
        }
        this.isSubmitting = false;
      },
      error: (err) => {
        //console.error('Error submitting feedback', err);
        this.isSubmitting = false;
      }
    });
  }


  cancelFeedback() {
    this.defaultSelects = this.defaultSelects.map(() => 0);
  }
}